import React from 'react';
import { Icon } from '../../../../components/icons';
import { BRAND, getThemeColors } from '../../../../lib/theme';
import type { DashboardData } from '../types';

interface EmailWidgetProps {
  mode: 'full' | 'summary';
  dark: boolean;
  data: DashboardData | null;
  tr: (k: string, opts?: Record<string, unknown>) => string;
}

export function EmailWidget({ mode, dark, data, tr }: EmailWidgetProps) {
  const t = getThemeColors(dark);
  const count = data?.badges?.communication ?? null;

  if (mode === 'summary') {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <Icon.Mail c={BRAND} />
        {count !== null
          ? <span style={{ fontSize: 13, color: t.text }}><strong style={{ color: t.heading }}>{count}</strong> {tr('dashboard.widget.email.unread_messages')}</span>
          : <span style={{ fontSize: 12, color: t.muted }}>{tr('dashboard.widget.loading')}</span>
        }
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', background: dark ? '#1a1f2b' : '#f9fafb', borderRadius: 10 }}>
        <Icon.Mail c={BRAND} />
        <div>
          <div style={{ fontSize: 13, fontWeight: 600, color: t.heading }}>
            {count !== null ? tr('dashboard.widget.email.count_messages', { count }) : '—'}
          </div>
          <div style={{ fontSize: 11, color: t.muted }}>{tr('dashboard.widget.email.available_in_system')}</div>
        </div>
      </div>
    </div>
  );
}
